import { Component, Inject, OnInit, ViewChild, OnDestroy, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PlantingService } from '../planting-settings/service';
import { trackDialogView } from '../../classes/trackDialogView';
import { AppliedFertilizerChartService } from './applied-fertilizer-chart-service';

@Component({
	moduleId: module.id,
	selector: 'applied-fertilizer-chart',
	templateUrl: 'applied-fertilizer-chart.html'
})

export class AppliedFertilizerChartComponent implements OnInit, OnDestroy {

	@ViewChild('chartContainer', { static: true }) private _chartContainer: ElementRef;
	public plantingName: string;
	private _subscriptions$: Subject<boolean>;
	private _appliedFertilizerChartService: AppliedFertilizerChartService;

	constructor(
		private _service: PlantingService,
		private _dialogRef: MatDialogRef<AppliedFertilizerChartComponent>,
		@Inject(MAT_DIALOG_DATA) private _data: { lotPlantingId: number, name: string },
	) {
	}

	ngOnInit(): void {
		this._subscriptions$ = new Subject();
		this._configureClickOutside(this._subscriptions$, this._dialogRef);
		trackDialogView('applied_fertilizer_chart_dialog');

		if (!this._data) {
			throw new Error('data is empty');
		}

		this.plantingName = this._data.name;

		this._appliedFertilizerChartService = new AppliedFertilizerChartService(this._chartContainer);

		this._service.getAppliedFertilizerChart(this._data.lotPlantingId).then(response => {
			this._appliedFertilizerChartService.convertToGraphData(response);
			this._appliedFertilizerChartService.drawChart();
		});
	}

	ngAfterViewInit() {
	}

	ngOnDestroy(): void {
		if (!this._subscriptions$) {
			return;
		}

		this._subscriptions$.next(true);
		this._subscriptions$.complete();
	}

	public cancel(): void {
		this._dialogRef.close();
	}

	private _configureClickOutside(s: Subject<boolean>, d: MatDialogRef<AppliedFertilizerChartComponent>): void {
		// custom click outside behavior
		d.disableClose = true;

		d.backdropClick().pipe(takeUntil(s)).subscribe(() => {
			d.close();
		});
	}
}
